import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-admin/major-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_ADMIN_MAJOR_MANAGE'],
    menu: {
      labelI18nKey: 'admin.company.majorManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.majorManagement.title',
        permission: ['PERM_ADMIN_MAJOR_MANAGE']
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.majorManagement.label.addMajor',
        permission: ['PERM_ADMIN_MAJOR_MANAGE']
      }
    },
    {
      path: `${basePath}/edit/:id`,
      component: Editor,
      meta: {
        isNewPage: true,
        isEdit: true,
        titleI18nKey: 'admin.company.majorManagement.label.editMajor',
        permission: ['PERM_ADMIN_MAJOR_MANAGE']
      }
    }
  ]
}
